export default {
	'the-offer': 'the offer?',
	offer: 'offer',
	'add-new-offer': 'add new offer',
}